import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "footerImages" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "middleTextImg" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "footerImages" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "footerImages2" }
const _hoisted_10 = ["src"]

import { FooterImagesItem, useNavigation } from '@/view/home/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'footerImages',
  props: {
    itemData: {}
  },
  emits: ['openContactPopup'],
  setup(__props: any, { emit: __emit }) {

const { goToPath } = useNavigation()
const emits = __emit
const props = __props
const openContactPopup = () => {
    emits('openContactPopup')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.itemData?.footerImage1?.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.itemData?.footerImage1?.url,
            alt: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToPath)(_ctx.itemData?.footerImage1?.redirectUrl)))
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.itemData?.footerImage2?.display)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.itemData?.footerImage2?.url,
              alt: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPath)(_ctx.itemData?.footerImage2?.redirectUrl)))
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.itemData?.htmlFooterTextTop?.display)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "middleText",
              innerHTML: _ctx.itemData?.htmlFooterTextTop?.text
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      (_ctx.itemData?.footerImage3?.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.itemData?.footerImage3?.url,
            alt: "",
            onClick: openContactPopup
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.itemData?.footerImage4?.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.itemData?.footerImage4?.url,
            alt: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPath)(_ctx.itemData?.footerImage4?.redirectUrl)))
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.itemData?.footerImage5?.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.itemData?.footerImage5?.url,
            alt: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(goToPath)(_ctx.itemData?.footerImage1?.redirectUrl)))
          }, null, 8, _hoisted_10))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})